import React, { useState, useEffect } from "react";
import { fetchResults } from "../utils/fetchData";
import { Col, Button } from "react-bootstrap";
import TableAdmin from "../component/TableAdmin";
import { useNavigate } from "react-router-dom";

const Result = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const handleDataChange = fetchResults((data) => {
      setResults(data);
      setLoading(false); // Set loading to false once data is fetched
    });
    const subscribe = handleDataChange();
    return () => {
      if (subscribe) subscribe();
    };
  }, []);

  const columns = [
    { key: "id", label: "No." },
    { key: "email", label: "Email" },
    { key: "name", label: "Name" },
    { key: "personalityType", label: "Personality" },
    { key: "completionDate", label: "Completion Date" },
  ];

  const handleDetail = (item) => {
    navigate(`/adminJaya/detailRes/${item.psychTestId}/${item.uid}/${item.resultId}`);
  };

  return (
    <>
      <Col md={12} className="d-flex justify-content-between align-items-center mt-3 px-3">
        <div className="d-flex">
          <h2>List Result Psikotes</h2>
        </div>
      </Col>
      <Col md={12}>
        <TableAdmin
          columns={columns}
          data={results}
          loading={loading} // Pass loading state
          hideActions={false} // Ensure actions are visible for this table
          customActions={(item) => (
            <Button className="btn-detail-result" onClick={() => handleDetail(item)}>
              <i className="bi bi-card-heading"></i>
            </Button>
          )}
        />
      </Col>
    </>
  );
};

export default Result;
